module.exports = __webpack_public_path__ + "img/daniel.fa86617a.png";